import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 4px;
  padding-right: 4px;
`;

export default Wrapper;
